import { createClass as _createClass, classCallCheck as _classCallCheck } from "../_virtual/_rollupPluginBabelHelpers.js";
import XGLogger from "../plugins/logger/index.js";
import Replay from "../plugins/replay/index.js";
import Poster from "../plugins/poster/index.js";
import Start from "../plugins/start/index.js";
import Enter from "../plugins/enter/index.js";
import MobilePlugin from "../plugins/mobile/index.js";
import Loading from "../plugins/loading/index.js";
import Progress from "../plugins/progress/index.js";
import Play from "../plugins/play/index.js";
import Fullscreen from "../plugins/fullscreen/index.js";
import Time from "../plugins/time/index.js";
import Rotate from "../plugins/rotate/index.js";
import PlayNextIcon from "../plugins/playNext/index.js";
import Download from "../plugins/download/index.js";
import ScreenShot from "../plugins/screenShot/index.js";
import DefinitionIcon from "../plugins/definition/index.js";
import PlaybackRate from "../plugins/playbackRate/index.js";
import Volume from "../plugins/volume/index.js";
import ErrorPlugin from "../plugins/error/index.js";
import Prompt from "../plugins/prompt/index.js";
import Thumbnail from "../plugins/common/thumbnail.js";
import PIP from "../plugins/pip/index.js";
import MiniProgress from "../plugins/progress/miniProgress.js";
import ZH from "../lang/zh-cn.js";
var DefaultPreset = /* @__PURE__ */ _createClass(function DefaultPreset2() {
  _classCallCheck(this, DefaultPreset2);
  var contolsIcons = [MobilePlugin, Progress, Play, Fullscreen, Time, Rotate, PlayNextIcon, DefinitionIcon, PlaybackRate, Download, ScreenShot, Volume, PIP];
  var layers = [Replay, Poster, Start, Loading, Enter, ErrorPlugin, Prompt, Thumbnail, MiniProgress];
  this.plugins = [XGLogger].concat(contolsIcons, layers);
  this.ignores = [];
  this.i18n = [ZH];
});
export { DefaultPreset as default };



//////////////////
// WEBPACK FOOTER
// ./node_modules/_xgplayer@3.0.5@xgplayer/es/presets/mobile.js
// module id = null
// module chunks = 